import { dictionarySection } from "@/content/i18n/dictionaries";
import type { Locale } from "@/lib/i18n/config";

export type Metric = { label: string; value: string; hint?: string };
export type Perk = { title: string; body: string };
export type Lane = { title: string; body: string };

export type AudienceContent = {
  beta: {
    eyebrow: string;
    title: string;
    body: string;
    socialProof: {
      eyebrow: string;
      quote: string;
      attribution: string;
    };
    perks: Perk[];
    cta: { label: string; href: string };
  };
  investors: {
    eyebrow: string;
    title: string;
    body: string;
    facts: Array<{
      label: string;
      value: string;
      hint?: string;
      icon: "stage" | "hq";
    }>;
    focusTitle?: string;
    focus?: string[];
    linkedinCtaLabel?: string;
    cta: { label: string; href: string };
  };
  collaborators: {
    eyebrow: string;
    title: string;
    body: string;
    lanes: Lane[];
    cta: { label: string; href: string };
  };
  finalCta: {
    title: string;
    body: string;
    primary: { label: string; href: string };
    secondary: { label: string };
  };
};

export function getAudiences(locale: Locale): AudienceContent {
  return dictionarySection(locale, "audiences") as AudienceContent;
}

export const audiences = getAudiences("en");
